import { DatePipe, DecimalPipe, LowerCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { PaymentMethod, PaymentType } from '@klubovna/api-client';
import { TranslateModule } from '@ngx-translate/core';
import { RecentOrdersService } from '@posServices';
import { SharedModule } from '@shared';

@Component({
  selector: 'app-recent-orders-dialog',
  standalone: true,
  imports: [ DatePipe, DecimalPipe, LowerCasePipe, MatDialogModule, TranslateModule, SharedModule ],
  templateUrl: './recent-orders-dialog.component.html',
  styleUrl: './recent-orders-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecentOrdersDialogComponent {
  private dialogRef = inject(MatDialogRef<RecentOrdersDialogComponent>);
  private recentOrdersService = inject(RecentOrdersService);

  protected readonly PaymentMethod = PaymentMethod;
  protected readonly PaymentType = PaymentType;

  recentOrders = this.recentOrdersService.recentOrders;
  hasOrders = this.recentOrdersService.hasOrders;
  hasMore = this.recentOrdersService.hasMore;
  loading = this.recentOrdersService.loading;

  loadMore(): void {
    this.recentOrdersService.loadMore();
  }

  close(): void {
    this.dialogRef.close();
  }
}
